<template>
  <el-container class="admin-shell" direction="vertical">
    <el-header height="64px" class="admin-header">
      <div class="brand-lockup">
        <img class="brand-mark" src="@/assets/cplus-brand-mark.svg" alt="">
        <div>
          <div class="platform-name">AI智能访谈服务平台</div>
          <div class="platform-subtitle">INTELLIGENT INTERVIEW</div>
        </div>
      </div>
      <div class="legacy-nav">
        <span>欢迎：</span><span>{{ displayName }}</span><span>({{ roleName }})</span><span> | </span>
        <a @click="openSettings">设置</a><span> | </span>
        <el-popover placement="bottom" trigger="hover">
          <div class="client-code">扫码下载安卓APP<br><img src="/aii/app/img/qrcode.png" alt="二维码"></div>
          <a slot="reference">客户端</a>
        </el-popover>
        <span> | </span><a @click="handleLogout">退出</a>
      </div>
    </el-header>

    <el-container class="shell-body">
      <el-aside width="224px" class="admin-sidebar">
        <div class="sidebar-title"><span>WORKSPACE</span>功能列表</div>
        <el-menu
          router
          :default-active="$route.path"
          background-color="#ffffff"
          text-color="#66718d"
          active-text-color="#5741ca"
        >
          <sidebar-menu-item v-for="item in menuItems" :key="item.id || item.path" :menu="item" />
        </el-menu>
      </el-aside>
      <el-main class="admin-main">
        <router-view />
      </el-main>
    </el-container>
    <el-dialog title="个人设置" :visible.sync="settingsVisible" width="400px" :close-on-click-modal="false">
      <el-form ref="settingsForm" :model="settings" label-width="82px">
        <el-form-item label="用户名:">
          <el-input v-model="settings.userName" readonly />
        </el-form-item>
        <el-form-item label="旧密码:">
          <el-input v-model="settings.password" type="password" />
        </el-form-item>
        <el-form-item label="新密码:">
          <el-input v-model="settings.newpassword" type="password" />
        </el-form-item>
        <el-form-item label="上传签名:">
          <input type="file" accept=".jpg,.JPG,.png,.PNG" @change="uploadSignature">
        </el-form-item>
        <div class="signature-box">
          <img v-if="settings.signature > 0" :src="signaturePreview" alt="">
        </div>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="saveSettings">确定</el-button>
        <el-button @click="settingsVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import SidebarMenuItem from '@/components/SidebarMenuItem.vue'
import { signatureUrl, updateLegacyProfile, uploadLegacySignature } from '@/api/platform-legacy'

export default {
  name: 'AdminLayout',
  components: {
    SidebarMenuItem
  },
  data() {
    return {
      settingsVisible: false,
      settings: { userId: '', userName: '', password: '', newpassword: '', signature: 0 }
    }
  },
  computed: {
    menuItems() {
      return (this.$store.getters.menus || []).filter(item => item.path !== '/dashboard')
    },
    breadcrumbs() {
      return this.$route.matched.filter(item => item.meta && item.meta.title)
    },
    userInfo() {
      return this.$store.getters.userInfo || {}
    },
    displayName() {
      return this.userInfo.realName || this.userInfo.userName || '未命名用户'
    },
    roleName() {
      return this.userInfo.roleName || '用户'
    },
    departmentName() {
      return this.userInfo.departmentName || ''
    },
    todoCount() {
      return Number(this.userInfo.todoCount || 0)
    },
    signaturePreview() {
      return signatureUrl(this.settings.signature)
    }
  },
  methods: {
    openSettings() {
      this.settings = {
        userId: this.userInfo.userId,
        userName: this.userInfo.userName,
        password: '',
        newpassword: '',
        signature: Number(this.userInfo.signature || 0)
      }
      this.settingsVisible = true
    },
    async uploadSignature(event) {
      const file = event.target.files && event.target.files[0]
      if (!file) return
      const result = await uploadLegacySignature(file)
      if (Number(result.errorCode) !== 0) {
        this.$message({ type: 'error', message: result.errorMsg, title: '抱歉！ 加载图片失败！' })
        return
      }
      this.settings.signature = Number(result.stringMediaId || 0)
    },
    async saveSettings() {
      const result = await updateLegacyProfile(this.settings)
      if (Number(result.errorCode) !== 0) {
        this.$message.error(result.errorMsg)
        return
      }
      this.settingsVisible = false
      await this.$store.dispatch('user/loadCurrentUser')
      this.reloadLegacyHome()
    },
    async handleLogout() {
      await this.$store.dispatch('user/logout')
      this.$router.replace('/login')
    },
    reloadLegacyHome() {
      // Session state was refreshed above. A full reload would erase the save toast.
      if (this.$route.path !== '/dashboard') this.$router.replace('/dashboard')
    }
  }
}
</script>

<style scoped>
.admin-shell {
  height: 100%;
}

.shell-body {
  min-height: 0;
}

.admin-sidebar {
  color: #66718d;
  background: linear-gradient(180deg, #fbfcff, #f4f5fc);
  border-right: 1px solid #e1e5f0;
  box-shadow: 6px 0 22px rgba(73, 85, 130, .04);
  scrollbar-color: #c7ccdb transparent;
  scrollbar-width: thin;
}

.admin-sidebar::-webkit-scrollbar {
  width: 5px;
}

.admin-sidebar::-webkit-scrollbar-thumb {
  background: #c7ccdb;
  border-radius: 5px;
}

.admin-sidebar ::v-deep .el-menu {
  border-right: none;
  background: transparent !important;
}

.admin-sidebar ::v-deep .el-menu-item,
.admin-sidebar ::v-deep .el-submenu__title {
  height: 44px;
  margin: 4px 12px;
  padding-right: 14px !important;
  line-height: 44px;
  border: 1px solid transparent;
  border-radius: 8px;
  transition: color 160ms ease, background 160ms ease, border-color 160ms ease;
}

.admin-sidebar ::v-deep .el-menu-item:hover,
.admin-sidebar ::v-deep .el-submenu__title:hover {
  color: #5741ca !important;
  background: rgba(130, 88, 244, .06) !important;
}

.admin-sidebar ::v-deep .el-menu-item.is-active {
  position: relative;
  color: #5630dc !important;
  background: linear-gradient(100deg, rgba(0, 223, 245, .2), rgba(52, 120, 255, .16) 46%, rgba(255, 67, 198, .17)) !important;
  border-color: rgba(123, 60, 255, .28);
  box-shadow: 0 8px 22px rgba(97, 77, 220, .12), inset 0 0 18px rgba(255, 255, 255, .58);
}

.admin-sidebar ::v-deep .el-menu-item.is-active::before {
  position: absolute;
  top: 9px;
  bottom: 9px;
  left: -13px;
  width: 3px;
  content: "";
  background: linear-gradient(#00dff5, #3478ff, #7b3cff, #ff43c6);
  box-shadow: 0 0 12px rgba(123, 60, 255, .45);
  border-radius: 0 3px 3px 0;
}

.admin-sidebar ::v-deep .el-menu-item i,
.admin-sidebar ::v-deep .el-submenu__title i {
  color: #8390ac;
}

.admin-sidebar ::v-deep .el-menu-item.is-active i {
  color: #7250db;
}

.sidebar-title {
  box-sizing: border-box;
  height: 54px;
  padding: 10px 22px;
  color: #48536f;
  font-size: 13px;
  font-weight: 600;
  background: rgba(255, 255, 255, .68);
  border-bottom: 1px solid #e7eaf2;
}

.sidebar-title span {
  display: block;
  margin-bottom: 3px;
  color: #8270dd;
  font: 9px/1 Arial, sans-serif;
  letter-spacing: 2px;
}

.admin-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 22px 0 18px;
  color: #58647e;
  background-color: #fff;
  background-size: 100% 100%;
  border-bottom: 1px solid #e4e8f2;
  box-shadow: 0 4px 18px rgba(70, 82, 130, .06);
}

.admin-header::before {
  position: absolute;
  z-index: 0;
  inset: 0;
  content: "";
  background: rgba(255, 255, 255, .92);
  backdrop-filter: blur(16px);
}

.admin-header::after {
  position: absolute;
  right: 22px;
  bottom: -1px;
  left: 254px;
  height: 1px;
  content: "";
  background: linear-gradient(90deg, #24cbd6, #5488ff 42%, #8258f4 72%, #ec5bce, transparent);
}

.admin-header > * {
  position: relative;
  z-index: 1;
}

.brand-lockup {
  display: flex;
  align-items: center;
}

.brand-mark {
  width: 38px;
  height: 38px;
  margin-right: 10px;
}

.user-entry {
  display: inline-flex;
  align-items: center;
  color: #374151;
  cursor: pointer;
}

.user-entry .el-icon-user-solid {
  margin-right: 6px;
}

.todo-badge {
  margin: 0 8px;
}

.admin-main {
  padding: 0;
  background: linear-gradient(135deg, #f7f9fd, #f3f5fb);
}
.platform-name { color: #19213d; font-size: 15px; font-weight: 600; letter-spacing: .4px; }
.platform-subtitle { margin-top: 3px; color: #8390ad; font: 8px/1 Arial, sans-serif; letter-spacing: 1.8px; }
.legacy-nav { display: flex; align-items: center; gap: 5px; color: #6f7a96; font-size: 13px; }
.legacy-nav a { color: #6254cb; cursor: pointer; text-decoration: none; }
.legacy-nav a:hover { color: #8b51d4; }
.client-code { text-align: center; font-size: 16px; }
.client-code img { width: 200px; height: 200px; }
.signature-box { width: 145px; height: 90px; margin: 0 auto; border: 1px solid #d6d6d6; }
.signature-box img { width: 100%; height: 100%; }

@media (max-width: 1366px) {
  .admin-sidebar {
    width: 208px !important;
  }

  .legacy-nav {
    font-size: 12px;
  }
}
</style>
